import { isBuffer as isBuffer$1 } from '../../predicate/isBuffer.mjs';

function isBuffer(x) {
    return isBuffer$1(x);
}

export { isBuffer };
